export enum SalesTaxProvider {
  Avalara = 'avalara',
  ZipTax = 'zip-tax',
}
